// import html stream theme first

//import '@/scss/calendar/fullcalendar.scss';
import jquery from 'jquery';
// import htmlsteram theme global libraries
//import 'jquery-migrate';
import 'bootstrap';
import '@/core/plugins/bootstrap-vue';
// backport some metronic 7 stuff
import '@/_integration/metronic-7/integration';
// NOTE: fancybox is NOT imported here — it is loaded lazily in _initPlugins only
// when the page actually has fancybox triggers (gallery Vue components self-import it).
import HSHeader from 'theme/assets/vendor/hs-header/dist/hs-header.min';
import HSUnfold from 'theme/assets/vendor/hs-unfold/dist/hs-unfold.min';
import 'theme/assets/js/hs.core';
import Vue from 'vue';
import JsRouting from 'fos-jsrouting-bundle';
import jsRoutes from '@/_res/fos_js_routes.json';
import './extends/vue-config';
import './extends/vue-filters';
import './extends/vue-directives';
import store from '@/core/services/store';
import {
  SET_USER_DATA,
  SET_USER_MENU,
  SET_USER_AVATAR,
  SET_CURRENT_SUBSCRIPTION,
  SET_WAITING_SUBSCRIPTION,
  SET_COOKIE_CONSENT_CATEGORIES,
  SET_ACL,
  RESET_USER_DATA
} from '@/core/services/store/profile.module';
import {
  SET_ENABLED_FEATURES
} from '@/core/services/store/system.module';
import FooterNewsletterSubscription
  from '@/promotion/components/footer-newsletter-subscription.vue';
import TokenService from '@/core/services/oauth.service';
// global axios configuration
import Axios from 'axios';
import ApiService from '@/core/services/api.service';
import Translator from 'bazinga-translator';
// import htmlsteram theme global libraries
import HSShowAnimation from 'theme/assets/vendor/hs-show-animation/dist/hs-show-animation.min';
// load translations
import '@/core/services/translations.service';
import TopbarUserProfile from './components/topbar-user-profile.vue';
import AsidePanel from './components/aside-panel.vue';
import CookieConsent from './components/cookie-consent.vue';
import userSessionPolling from './utils/user-session-polling';
import Subscription from '../accounting/models/Subscription';

// parsley (form validation) is loaded lazily in _initPlugins — off the critical
// path; form components use the global window.Parsley, and forms are never
// submitted before first paint.

import globalConfig from './config/app';
import XsrfUtils from './utils/xsrf-utils';
import guiUtil from './utils/gui';
import utils from './utils/general';
import HttpUtil from './utils/http';
import securityUtil from './utils/security';

// define JsRouting globally in browser scope
window.JsRouting = JsRouting;

// define JQuery aliases globally in browser scope
window.jQuery = jquery;
window.$ = jquery;

// define Translator globally in browser scope
window.Translator = Translator;

const axiosDefaults = require('axios/lib/defaults');

class Main {
  /**
   * init the main app
   */
  init() {
    const self = this;
    const $masterDef = $.Deferred();
    const $userDef = $.Deferred();

    $(document).ready(() => {
      self._initJsRouter();

      store.commit(SET_ENABLED_FEATURES, GLOBAL.features);

      // API service init
      ApiService.init();

      // init all following AJAX request defaults
      this._initAJAXDefaults();
      // for local development only
      //this._initDevOauthToken();

      // make request to set the api client key in browser
      // we do not do it in the main symfony rendering process because
      // setting cookies from PHP would prevent http caching by nginx
      self._initClientApiKey().done((result) => {
        // initialize frontend session polling
        const sessionPolling = new Vue(userSessionPolling);
        sessionPolling.pollData(true).always(() => {
          self._initUserData().always(() => {
            $userDef.resolve();
            // initialize the header part which contains
            self._initHeader();
            //self._initAside();
          });
          self._initCookieConsent();
          self._initMainCta();
          self._initFooter();
        });
      }).fail((error) => {
        console.log('session pooling failed');
        // without this cookie we are unable to reach the API
        // what to do next ???
        $userDef.reject();
      });

      self._initPlugins();

      XsrfUtils.initXsrfCookies();
      self._showFlashbagNotifications();

      $.when($userDef).then((data, textStatus, jqXHR) => {
        $masterDef.resolve();
      });
    });

    return $masterDef;
  }

  _initUserData() {
    const def = $.Deferred();
    const url = JsRouting.generate(ApiService.apiRoute('webapi_session_get_init_data'), {}, true);
    store.commit(SET_ACL, []);

    if (store.getters.isAnonymousVisit) {
      // no need to fetch user data since we already know we have a anonymous session
      store.dispatch(RESET_USER_DATA);
      def.resolve();
      return def;
    }

    Axios.get(url).then((response) => {
      if (response.data && response.data.user) {
        store.commit(SET_USER_DATA, response.data.user);
      }
      if (response.data && response.data.current_subscription) {
        store.commit(SET_CURRENT_SUBSCRIPTION, new Subscription(response.data.current_subscription));
      }
      if (response.data && response.data.waiting_subscription) {
        store.commit(SET_WAITING_SUBSCRIPTION, new Subscription(response.data.waiting_subscription));
      }
      if (response.data && response.data.menu) {
        store.commit(SET_USER_MENU, response.data.menu);
      }
      if (response.data && response.data.avatar) {
        store.commit(SET_USER_AVATAR, response.data.avatar);
      }
      store.commit(SET_ACL, (response.data && response.data.acl) ? response.data.acl : (securityUtil.getAcl() || []));
      def.resolve();
    }).catch((error) => {
      HttpUtil.axiosErroDefaultHandler(error).done((errorString) => {
      });
      // do nothing
      def.reject();
    });

    return def;
  }

  /**
   *
   * @private
   */
  _initAJAXDefaults() {
    const accessToken = TokenService.getToken();

    // Globally set some IMPORTANT defaults for Axios
    // These settings will be used for each requests in all vue components which will be called after this point
    // necessary to be able to reach the API (/webapi/...) from webpack dev server (cross domain request)
    // and pass the session cookie along
    axiosDefaults.withCredentials = true;
    axiosDefaults.credentials = 'same-origin';
    // We need this header for all AJAX requests done with Axios in order
    // for symfony to be able to identify an AJAX request on the backend side
    axiosDefaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    if (accessToken) {
      axiosDefaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    }

    // set global default for $.ajax calls
    const jqAjaxHeaders = {
      // We need this header for all AJAX requests done with $.ajax in order
      // for symfony to be able to identify an AJAX request on the backend side
      'X-Requested-With': 'XMLHttpRequest',
    };
    if (accessToken) {
      jqAjaxHeaders['Authorization'] = `Bearer ${accessToken}`;
    }
    $.ajaxSetup({
      headers: jqAjaxHeaders,
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
    });
  }

  /**
   * make request to set the api client key in browser
   * we do not do it in the main symfony rendering process because it
   * would prevent http caching by nginx
   *
   * @private
   */
  _initClientApiKey() {
    const $def = $.Deferred();
    const url = JsRouting.generate(ApiService.apiRoute('webapi_session_init_frontend_session'), null, true);
    Axios.get(url).then((result) => {
      $def.resolve(result);
    }).catch((error) => {
      HttpUtil.axiosErroDefaultHandler(error).done((errorString) => {});
      $def.reject(error);
    }).then(() => {
    });
    $def.resolve();
    return $def;
  }

  _initJsRouter() {
    // inject current locale into defaults for all routes which need it
    // because its value is not set correctly/at all by the JsRoutingbundle
    for (var routeName in jsRoutes.routes) {
      if (jsRoutes.routes.hasOwnProperty(routeName)) {
        if (jsRoutes.routes[routeName].hasOwnProperty('defaults')) {
          if (jsRoutes.routes[routeName].defaults.hasOwnProperty('_locale')) {
            jsRoutes.routes[routeName].defaults._locale = document.documentElement.lang;
          }
        }
      }
    }

    // initialize FosJsRouter
    JsRouting.setRoutingData(jsRoutes);

    // BEGIN: IMPORTANT custom Routing.generate implementation to inject _local parameter transparently
    // change name of initial method
    JsRouting.generateImpl = JsRouting.generate;
    // override generate function by adding a default _locale from html lang attribute
    JsRouting.generate = function (route, params, absolute) {
      let paramsExt = {};
      if (params) {
        paramsExt = params;
      }
      // if (!paramsExt._locale){
      //   paramsExt._locale = document.documentElement.lang;
      // }
      let url = null;
      try {
        url = JsRouting.generateImpl(route, paramsExt, absolute);
      } catch (err) {
        // try localized route
        delete paramsExt._locale;
        url = JsRouting.generateImpl(route + '.' + document.documentElement.lang, paramsExt, absolute);
      }
      return url;
    };
    // END: IMPORTANT custom Routing.generate implementation to inject _local parameter transparently
  }

  /**
   * Load bazingas js translation bundle translations
   * https://github.com/willdurand/BazingaJsTranslationBundle/blob/master/Resources/doc/index.md#loading-via-json
   * @param files
   * @private
   */
  static _httpFetchTranslations(files) {
    for (const filePath of files) {
      fetch(filePath)
        .then((response) => response.json())
        .then((data) => Translator.fromJSON(data));
    }
  }

  // static _initTranslations() {
  //   // Main._httpFetchTranslations([
  //   //   '@/translations/config.json',
  //   // ]);
  //   import(`@/../public/js/translations/config.js`);
  //   for (const langKey of ['en', 'pl']) {
  //     for (const bundleKey of [
  //       'messages', 'FOSUserBundle', 'FOSMessageBundle',
  //       'SonataMediaBundle', 'AppAccounting', 'AppCalendar', 'AppProduct'
  //     ]) {
  //       import(`@/../public/js/translations/${bundleKey}/${langKey}.js`);
  //       // Main._httpFetchTranslations([
  //       //   `/js/translations/${bundleKey}/${langKey}.json`,
  //       // ]);
  //     }
  //   }
  // }

  /**
   * init various JS plugins
   */
  _initPlugins() {
    // Parsley (form validation) — loaded OFF the critical path as its own async
    // chunk. Form components rely on the global window.Parsley; forms are never
    // submitted before first paint, so deferring its load/config is safe and
    // keeps ~43 KB out of the render-blocking bundle.
    import(/* webpackChunkName: "parsley" */ 'parsleyjs')
      .then(() => import(/* webpackChunkName: "parsley" */ 'parsleyjs/dist/i18n/pl'))
      .then(() => {
        window.Parsley.setLocale(document.documentElement.lang);
        window.ParsleyConfig = utils.deepClone(globalConfig.parsley.defaultConfig);
      });

    // Initialize KTApp class on document ready
    window.KTApp.init(window.KTAppOptions);

    function initTabindex() {
      // init a field with tabindex=1 if found
      $('[tabindex=1]').focus();
    }

    function initHsUnfold() {
      // initialization of unfold
      let unfold = null;
      $('.js-hs-unfold-invoker').each((key, el) => {
        unfold = new HSUnfold($(el)).init();
      });
    }

    initTabindex();
    initHsUnfold();

    // Fancybox (lightbox) — loaded as its own async chunk and ONLY when the page
    // has server-rendered fancybox triggers. Gallery Vue components self-import
    // fancybox, so this just covers static markup. Public pages (homepage) have
    // none → ~66 KB never loads there.
    if (document.querySelector('[data-fancybox], .js-fancybox')) {
      Promise.all([
        import(/* webpackChunkName: "fancybox" */ '@fancyapps/fancybox/dist/jquery.fancybox'),
        import(/* webpackChunkName: "fancybox" */ 'theme/assets/js/hs.fancybox'),
      ]).then(() => {
        $(document).find('.js-fancybox').not('[data-fancybox-initialized="true"]').each((key, el) => {
          $.HSCore.components.HSFancyBox.init($(el));
          $(el).attr('data-fancybox-initialized', 'true');
        });
        $('[data-fancybox]').fancybox({
          toolbar: false,
          smallBtn: true,
          buttons: ['fullScreen', 'close'],
          iframe: { preload: true },
        });
      });
    }
  }

  _showFlashbagNotifications() {
    if (window.GLOBAL.notifications.length > 0) {
      // process current symfony flash notifications - may be refactored to AJAX request in future
      $.each(window.GLOBAL.notifications, function (key, notification) {
        if (notification.type > '') {
          // Sonata backend flashes must never leak into frontend Swal notifications.
          if (notification.type.indexOf('sonata_flash_') === 0) {
            return;
          }

          notification.type = (notification.type === 'notice' ? 'info' : notification.type);
          guiUtil.showNotification(notification.type,
            notification.message,
            null,
            {
              timeOut: '8000',
              onHidden() {
              },
            }
          );
        }
      });
    }
  }

  /**
   * Fetch an Oauth2 access token from the main app
   * to be able to access the /webapi/ endpoints from mockup/frontend-dev
   * in context of eg encore dev server
   * @private
   */
  _initDevOauthToken() {
    let date = new Date();
    let vm = this;
    let accessCookie;
    let $def = $.Deferred();
    let $innerDef = $.Deferred();

    /**
     * Oauth dev token for frontend GUI work
     */
    accessCookie = new RegExp('(?:^|; )' + encodeURIComponent('DEV-ACCESS-TOKEN') + '=([^;]*)').exec(document.cookie);
    if (!accessCookie) {
      let accessTokenUrl = JsRouting.generate('fos_oauth_server_basic_auth_backdoor', null, true);
      Axios.get(accessTokenUrl)
        .then((response) => {
          if (response.data.access_token > '') {
            // set oauth access token as cookie
            let expires = response.data.expires_at;
            date.setTime(expires * 1000);
            expires = '; expires=' + date.toUTCString();
            document.cookie = 'DEV-ACCESS-TOKEN=' + (response.data.access_token || '') + expires + '; path=/';
            $innerDef.resolve({
              access_token: response.data.access_token,
            });
          } else {
            console.warning('Could not get Oauth2 access data');
            $innerDef.resolve();
          }
        })
        .catch((error) => {
          HttpUtil.axiosErroDefaultHandler(error).done((errorString) => {
            vm.answer = 'Error! Could not reach the API. ' + errorString;
            $innerDef.resolve(); // resolve even in error case - we might work on frontend without the need of authenticated API access
          });
        });
    } else {
      $innerDef.resolve(accessCookie[1]);
    }

    $.when($innerDef).done((accessToken) => {
      if (accessToken) {
        // set global default for $.ajax calls
        $.ajaxSetup({
          headers: {
            'Authorization': 'Bearer ' + accessToken,
          },
        });
        // set global default for Axios calls
        Axios.defaults.headers.common = {
          'Authorization': 'Bearer ' + accessToken,
        };
      }

      $def.resolve();  // resolve even in error case - we might work on frontend without the need of authenticated API access
    });

    return $def;
  }

  /**
   *
   * @private
   */
  _initHeader() {
    /**
     * #header
     */
    ((id) => {
      const appContainer = document.getElementById(id);
      if (appContainer) {
        const app1 = new Vue({
          el: appContainer,
          components: {
            TopbarUserProfile,
          },
          mounted() {
            const self = this;
            self.init();
          },
          methods: {
            init() {
              // BEGIN initialize metronic elements (again)
              // here after vue has mounted the #kt_header container
              // the first time this initializations happen in scripts.bundle.js
              // but we must do it again after vue has processed the HTML code

              // initialization of header
              const $header = $('#header');
              const header = new HSHeader($header).init();

              const normalizeHeaderInitialState = () => {
                const scrollTop = Math.max(
                  window.pageYOffset || 0,
                  document.documentElement ? document.documentElement.scrollTop : 0
                );

                if (scrollTop <= 2) {
                  $header.removeClass('js-header-fix-moment scrolled header-moved-up header-faded header-invisible');
                }
              };

              // Guard against transient initial scroll values causing a first-paint "shrunk" flash.
              normalizeHeaderInitialState();
              window.setTimeout(normalizeHeaderInitialState, 80);
              $(window)
                .off('load.appHeaderInitialState')
                .on('load.appHeaderInitialState', normalizeHeaderInitialState);

              // Enable header padding transition only after initial layout settles.
              window.setTimeout(() => {
                $header.addClass('header-ready');
              }, 120);
            },
          },
        });
      }
    })('header');
  }

  /**
   *
   * @private
   */
  _initAside() {
    /**
     * #sidebarContent
     */
    ((id) => {
      const appContainer = document.getElementById(id);
      if (appContainer) {
        const app1 = new Vue({
          el: appContainer,
          components: {
            AsidePanel,
          },
          mounted() {
            const self = this;
            self.init();
          },
          methods: {
            init() {
            },
          },
        });
      }
    })('sidebarContent');
  }

  /**
   *
   * @private
   */
  _initMainCta() {
    /**
     * #main-cta
     */
    ((id) => {
      const appContainer = document.getElementById(id);
      if (appContainer) {
        const app1 = new Vue({
          el: appContainer,
          components: {
            FooterNewsletterSubscription,
          },
          methods: {
            blockUi(flag) {
              if (flag) {
                guiUtil.blockUI($(`#${id}`));
              } else {
                guiUtil.unblockUI($(`#${id}`));
              }
            },
          },
        });
      }
    })('main-cta');
  }

  /**
   *
   * @private
   */
  _initCookieConsent() {
    ((id) => {
      const appContainer = document.getElementById(id);
      if (appContainer) {
        const app1 = new Vue({
          el: appContainer,
          components: {
            CookieConsent,
          },
          computed: {
            cookieConsentTools() {
              return window.cookieConsentTools;
            },
          },
          methods: {
            cookieConsentGiven() {
              if (!store.state.profile.cookieConsentCategories) {
                store.commit(SET_COOKIE_CONSENT_CATEGORIES, this.cookieConsentTools.getAllowedCategories());
              }
              // final try to call registered callbacks after given,
              // they will not trigger if according cookie consent not given
              // they will also only trigger once
              this.cookieConsentTools.triggerAllHeaderCallbacks();
            },
          },
        });
      }
    })('cookie-consent');
  }

  /**
   *
   * @private
   */
  _initFooter() {
    /**
     * #footer
     */
    ((id) => {
      const appContainer = document.getElementById(id);
      if (appContainer) {
        const app1 = new Vue({
          el: appContainer,
          components: {
            FooterNewsletterSubscription,
          },
        });
      }
    })('footer');
  }
}

export default new Main();
